export default {
  en: {
    general: {
      time: 'Time',
      airport: 'airport',
      please_select: 'Please select',
      select: 'Select',
      quote_expired: 'Your quote has expired',
      search_again: 'Search again',
      miles: 'miles',
      offline: 'Offline',
      online: 'Online'
    },
    loader: {
      bullet_1: 'Contacting suppliers',
      bullet_2: 'Checking availability',
      bullet_3: 'Finding the best prices',
      bullet_4: 'Applying quality score',
    },
    banner: {
      home: 'Home',
      results: 'Search Results',
      airport: 'airport',
      return: 'Return to results',
      hotels: 'Airport Hotels with parking',
      lounges: 'Airport lounges',
      thank_you: 'Thank you',
      payment_complete: 'Payment complete',
      update_complete: 'Booking updated',
      processing: 'Processing',
      amending: 'Updating',
      sending_booking: 'Your booking is being sent to our suppliers',
      error: 'Error'
    },
    reevoo: {
      read: 'Read',
      reviews: 'reviews'
    },
    airportlounge: {
      filters: {
        departure_date: 'Departure Date',
        adults: 'Adults (12+)',
        children: 'Children (1-12)',
        infants: 'Infants (0-1)'
      },
      results: {
        available: 'lounges available from',
        on: 'on',
        terminal: 'Terminal',
        book_now: 'Book now',
        opening_hours: 'Opening hours',
        view_more_info: 'View more info',
        booking_price: 'Booking price',
        add_to: 'Add to booking'
      },
      payment: {
        from: 'From'
      }
    },
    airporthotel: {
      filters: {
        night_of_stay: 'Night of stay',
        parking_until: 'Parking until',
        room_type: 'Room type',
        search: 'Search'
      },
      results: {
        available: 'hotels with parking have rooms available',
        room: 'room',
        transfers: 'transfers',
        map: 'map',
        food_drink: 'food & drink',
        parking: 'parking',
        book_price: 'Booking Price',
        journey: 'Journey Time',
        charges: 'Charges',
        restaurants: 'Restaurants',
        breakfast: 'Breakfast',
        book_now: 'Book now',
        important: 'IMPORTANT'    
      },
      payment: {
        staying: 'Staying on',
        parking: 'Parking to',
        night_before: 'night before your flight',
      }
    },
    airportparking: {
      results: {
        product: {
          recommended: 'Recommended',
          transfer: 'min. transfer',
          to: 'to',
          from: 'from',
          the: 'the',
          park_mark: 'park mark award',
          more_info: 'view more info',
          options: 'Booking Options',
          save: 'Save for later',
          saved: 'Saved, please check your emails.',
          save_button: 'Save',
          cancel: 'cancel',
          price_for: 'Price for',
          days_parking: 'days parking',
          last: 'Last booked',
          viewing: 'persons currently viewing',
          cheaper_discount: 'Cheaper - Saving',
          cheaper_discount_saving: 'Saving',
          book_now: 'Book now',
          email_address: 'Email address',
          walk: 'Short walk to the terminal',
          reveal_promo: 'Reveal discount',
          reveal_discount: 'Reveal discount',
          reveal_join: 'Join our mailing list to activate now',
          activate: 'Activate',
          cashback: 'Cashback',
          no_cashback: ' No cashback',
          no_cashback_explainer: 'No cashback when promo code used. To gain cashback you will need to remove the promo code and search again'
        },
        map: {
          book_now: 'Book now',
          more_info: 'More info'
        },
        subtitle: 'search results for',
        promo: {
          placeholder: 'PROMO CODE',
          active: 'Your promo code is active',
          invalid: 'Invalid promo code'
        },
        filters: {
          clear: 'clear filters',
          empty: 'No products to show',
          quoted: 'Quoted',
          car_parks: 'car parks',
          edit: 'Edit',
          search: 'Search',
          search_again: 'search again',
          show: 'show filters',
          terminal: 'Filter By Terminal',
          map: 'Map View',
          order: 'Order By',
          drop_off_label: 'Drop Off Date & Time',
          pick_up_label: 'Pick Up Date & Time',
          filter_by: 'Filter By',
          searching: 'Searching...',
          invalid_times: 'Drop Off date must be before Pick Up date.'
        },
        sort: {
          recommended: 'Recommended',
          price_low: 'Price - low to high',
          price_high: 'Price - high to low'
        },
        type: {
          all: 'All',
          on: 'On-Airport',
          off: 'Off-Airport',
          meet_greet: 'Meet & Greet'
        },
        save: 'Save for later ',
        save_fill: 'Simply fill in your email address and get the quote sent to your inbox.',
        no_hotels: 'Sorry we didn\'t find any hotel rooms available for your search',
        cars_available_1: 'However there are ',
        cars_available_2: 'car parks with available spaces',
      }
    },
    payment: {
      confirm_booking: 'Confirm Booking',
      upgrades: 'Upgrades',
      edit: {
        new_price: 'The price for your selected times is',
        vehicles: 'per vehicle',
        new_product: 'is not available for your chosen times',
        incorrect_date: 'Return time cannot be before arrival time',
        updated: 'Your cart has been updated',
        return: 'Return to payment',
        cancel: 'Cancel',
        update_cart: 'Update basket with new times',
        price_difference: 'Price difference',
      },
      card: {
        invalid_card: 'Invalid card number',
        card_number: 'Card number',
        expiry_date: 'Expiry date',
        security: 'Security code',
        errors: {
          card_number: 'Please enter a valid card number',
          expiry_date: 'Please enter a valid expiry date',
          cvv: 'Please enter a valid cvv code',
        }
      },
      basket: {
        more_info: 'More Info',
        from: 'From',
        to: 'To',
        at: 'at',
        total_to_pay: 'Total to Pay',
        customer_credits: 'Credits',
        customer_credits_used: 'Credits used',
        on_making_payment: 'On making payment you agree to our booking',
        terms: 'terms and conditions',
        car_terms: 'Car park terms and conditions',
        edit: 'Edit times',
        edit_cancel: 'Cancel edit',
        cancel: 'Cancel',
        skip: 'Skip this step',
        recommended: 'Recommended Extras',
        free: 'FREE'
      },
      customer: {
        confirmation_to: 'Email confirmation to',
        email: 'Email',
        password: 'Password',
        welcome_back: 'Welcome back',
        title_forgotten_password: 'Forgotten password',
        request_forgotten_password: 'Just enter your email address and we will send you a new password',
        incorrect_email_password: 'Wrong email or password. Please try again',
        continue_password: 'Continue without password',
        forgotten_password: 'Forgotten password?',
        why_sign_up: 'Tick this box if you do not want to receive emails from SkyParkSecure regarding information about discounts, competitions, services and announcements.',
        confirmation_to_email: 'Your booking confirmation, directions, important pre-travel information will be sent to the booking email address.',
        customer_information: 'Customer information',
        first_name: 'First name',
        title: 'Title',
        last_name: 'Last name',
        mobile: 'Mobile number',
        request: 'Request password',
        log_in: 'Log in',
        logout: 'Logout',
        titles: {
          mr: 'Mr',
          ms: 'Ms',
          mrs: 'Mrs',
          miss: 'Miss',
          dr: 'Dr'
        },
        change_times: 'Change times',
        return_time: 'New drop off time',
        arrival_time: 'New pick up time',
        password_change: {
          email_sent: 'A password reset email has been sent. Please check your email',
          error: 'Sorry, we don\'t recognise this email address'
        },
        adult: 'Adult',
        child: 'Child',
        infant: 'Infant',
        no: 'no',
        create_password: 'Create password',
        confirm_password: 'Confirm password',
        password_title: 'Save information for faster checkout next time',
        save_password: 'Save password and complete order',
        without_password: 'Continue without password'
      },
      vehicle: {
        car_details: 'Your car details',
        registration: 'Registration',
        your_reg: 'Your reg',
        lookup: 'Lookup',
        number_passengers: 'Passengers',
        make: 'Make',
        model: 'Model',
        color: 'Colour',
        details: 'details',
        car: 'Car',
        cars: 'cars',
        remove: 'remove',
        add: 'Add extra car',
        error: 'No vehicle found, please enter your car details manually',
        existing_vehicles: 'Your existing vehicles',
        existing_vehicle: 'Existing vehicles'
      },
      travel: {
        flight_details: 'Flight details',
        flight_details_optional: 'Flight details (optional)',
        confirm: 'Confirm flight details when dropping off your vehicle or add now to save time.',
        outbound: 'Outbound flight number',
        terminal_out: 'Terminal out',
        inbound: 'Inbound flight number',
        terminal_in: 'Terminal in',
        meet_greet: 'Outbound meet time',
        meet_greet_confirm: 'Only required for Meet & Greet services. Please choose the time you would like to be met at the terminal. Don\'t forget to allow enough time for check-in',
        meet_time: 'Time',
        parking: 'Parking details',
        parking_arrival: 'Parking arrival time',
        parking_departure: 'Parking departure time'
      },
      addon: {
        peace_of_mind: 'For your peace of mind',
        add: 'Add',
        for: 'for',
        extras: 'Extras',
        cancel: 'Cancel for free',
        sms: 'Free SMS'
      },
      payment: {
        make_payment: 'Make payment',
        make_booking: 'Make booking',
        paypal: 'Paypal',
        card: 'Debit/Credit card',
        total_to_pay: 'Total to pay',
        error: {
          failed: 'Payment failed. Please try again',
          wrong_try_again: 'Something went wrong, the booking was not created. Please try again',
          wrong_try_again_cs: 'Something went wrong, the booking was not created. Please contact our customer services team',
          already_exists: 'Sorry, this booking could not be created. This booking already exists. Please contact our Customer services as payment for your booking was taken',
          expired: 'Sorry, this quote has expired. Please contact our customer service team',
          credits: 'Sorry, your credits have expired. Please try again'
        }
      }
    },
    more_info: {
      book_now: 'Book now',
      reasons: 'Reasons to book',
      overview: 'Overview',
      latest_review: 'Latest review',
      latest_reviews: 'Latest reviews',
      no_reviews: 'This product is awaiting reviews',
      out_of: 'out of',
      transfers: 'Transfers',
      directions_car: 'Directions to car park',
      on_arrival: 'On arrival to the car park',
      on_return: 'On your return',
      important_info: 'Important info',
      security: 'Security',
      insurance: 'Insurance',
      disabled: 'Disabled facilities',
      facilities: 'Facilities',
      opening_hours: 'Opening hours',
      what_you_should_know: 'What you should know',
      description_of: 'Description of',
      rooms: 'Rooms',
      restaurant: 'Restaurant',
      breakfast: 'Breakfast',
      leisure: 'Leisure',
      transfer: 'Airport Transfer Details',
      journey: 'Airport Transfer/Journey Time',
      charge: 'Airport Transfer Charge',
      parking: 'Parking Arrangements',
      additional_days: 'Additional Days Parking Charge',
      additional: 'Additional Notes',
      check_in: 'Check in time',
      check_out: 'Check out time',
      tabs: {
        summary: 'Summary',
        on_arrival: 'On arrival',
        on_return: 'On return',
        important: 'Important',
        map: 'Map',
        reviews: 'Reviews',
        overview: 'Overview',
        full_information: 'Full information'
      },
      right: {
        on_airport: 'On Airport',
        walking_distance: 'Walking distance to the airport',
        min: 'min',
        transfer_time: 'transfer time',
        meet_greet: 'Meet & Greet',
        met_terminal: 'You will be met at the terminal',
        distance_airport: 'from the airport'
      }
    },
    confirmation: {
      account: 'View this booking in your account',
      booking_ref: 'booking reference(s)',
      vehicle: 'Vehicle',
      confirmation: 'Confirmation',
      no_booking: 'Booking not found',
      view_booking: 'View',
      print: 'Print',
      credits: 'Credits used',
      please_print: 'Please print off the booking confirmation',
      error_confirming: 'Sorry, your booking could not be created',
      booking_not_found: 'No booking was found',
      error_not_created: 'Something went wrong. Booking was not created',
      error_not_created_contact: 'Payment taken, but booking was NOT made - Please contact our Customer Services',
      in_progress: 'Your booking is being processed. It can take up to 3 minutes to confirm your payment. Please do not close or refresh this page',
      in_progress_amending: 'Your booking is being updated. It can take up to 3 minutes to confirm your payment. Please do not close or refresh this page',
      thank_you: 'Thank you for making a booking with',
      thank_you_updated: 'Thank you for updating your booking',
      order_id: 'Your order ID',
      total_cost: 'Your total cost from this transaction was',
      happens_next: 'What happens next?',
      happens_next_point_1: 'In a few minutes you\'ll receive an email confirmation which you should print off and take with you to the car park/hotel/lounge.',
      happens_next_point_2a: 'The confirmation will contain all appropriate contact numbers and directions.',
      happens_next_point_2b: 'If you have a Hotmail, Live, MSN or Gmail email address',
      happens_next_point_3: 'If your Booking Confirmation does not appear in your Inbox then please check any Junk, Promotion or Spam Folders you may have in case it has been filtered out by your email provider.',
      happens_next_point_4a: 'If your Booking Confirmation has been filtered out by your email provider then please mark our email address,',
      happens_next_point_4b: 'as safe to enable us to contact you with any important pre-travel information should we need to do so.',
      happens_next_point_5: 'Any important pre-travel information we need to pass on to yourself will be done via email only and by failing to mark our email address as safe could prevent you from recieving this.',
      view: {
        privacy_policy: 'Privacy policy',
        did_not_make: 'If you did not make this booking',
        click_here: 'click here',
        copyright: 'Copyright',
        rights_reserved: 'All rights reserved',
        your_booking: 'here is your booking confirmation',
        please_read: 'Please read and save the details below carefully prior to your journey',
        terms_short: 'terms and conditions - short version',
        full_terms: 'Full Terms and Conditions',
        parking_req: 'Parking requirements',
        must_ensure: 'You must ensure that, before leaving the vehicle with the car parking company that it is in a roadworthy condition, taxed and hold a current MOT if applicable. All vehicles are parked at the owners risk and we do not accept liability for any loss or damage to any vehicle or its interior. Customers are advised to check their vehicle on arrival and on departure from the airport/car park, as once the vehicle has left the airport/car park no liability issues will be entered into.',
        booking_agent: 'Skyparksecure is a booking agent only',
        is_an_agent: 'Skyparksecure Ltd is an agent for the featured car parks. You will be contracting with the individual car park and will be subject to their Terms and Conditions which may contain exemption clauses and limit each companys liability. Full details of these are available from the individual car park.',
        cancellation_policy: 'Cancellation policy',
        non_applicable: '(Not applicable to non-cancellable or non-amendable products)',
        direct_cancellation: 'All cancellations must be made directly through Skyparksecure in order to be valid. (Not with the car park).',
        please_send: 'Please send an e-mail to',
      }
    }
  },
}